const { callAuthorizedGraphQLEndpoint } = require('../../../../Module/graphQL')

const getMissionsByCity = queryVars => {
  const query = `query (
    $first:Int
    $skip:Int
    $cityId:ID!
    $clientId:ID
    $locationId:ID
    $campaignId:ID
    $startDate:String
    $endDate:String
    $statusAndAbove: MissionStatusEnum
    $statusAndBelow: MissionStatusEnum
    $timeOfDay: MissionTimeOfDayEnum
    $filter:String
    $orderBy:MissionOrderByEnum
    $dayOfTheWeek:DayOfTheWeekEnum
    $reported: Boolean
  ) {
    city(id: $cityId){
      id
      name
      country { id }
      lunchCheckInTime
      afternoonCheckInTime
      missions(
        first: $first
        skip: $skip
        clientId: $clientId
        locationId: $locationId
        campaignId: $campaignId
        startDate: $startDate
        endDate: $endDate
        statusAndAbove: $statusAndAbove
        statusAndBelow: $statusAndBelow
        timeOfDay: $timeOfDay
        filter: $filter
        orderBy: $orderBy
        dayOfTheWeek: $dayOfTheWeek
        reported: $reported
      ){
        edges {
          node {
            id
            dateTime
            flyerCode
            flyerCodeV2 {
              tag
              code
            }
            status
            totalFlyersDistributed
            rating
            cityPlan {
              campaign {
                client {
                  name
                }
                metrics {
                  nodes {
                    id
                    name
                  }
                }
              }
              city {
                afternoonCheckInTime
                lunchCheckInTime
              }
            }
            location {
              name
            }
            user {
              firstName
              lastName
            }
            metricResults {
              nodes {
                value
                metric {
                  id
                  name
                }
              }
            }
            amountScans
            canBeSpied
            spyInformation{
              spy{
                id
                firstName
                lastName
              }
              spyDetails{
                checkInTime
                checkoutTime
                reportReason
                }
              shift{
                id
              }
            }
            campaign{
            name
            }
          }

        }
        pageInfo {
          hasNextPage
        }
        totalCount
      }
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, queryVars)
}

const updateMission = async input => {
  const query = `mutation updateMission($input: UpdateMissionInput!){
      updateMission(input: $input){
         mission{
        id
        canBeSpied
        }
      }
    }
  `

  return callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

const bookSpyMissions = async input => {
  const query = `mutation bookSpyMissions($input: BookSpyMissionsInput!){
    bookSpyMissions(input: $input){
      nodes{
       id
      }
    }
  }
  `

  return callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

const deleteSpyShift = async input => {
  const query = `mutation deleteSpyShift($input: DeleteSpyShiftInput!){
    deleteSpyShift(input: $input){
      success
    }
  }
  `

  return callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

export { getMissionsByCity, updateMission, bookSpyMissions, deleteSpyShift }



// WEBPACK FOOTER //
// ./src/Containers/City/Page/MasterSchedule/gql.js